import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ProfileImageCrop, ProfileImageUploadData, FileSize, FormBase, Optional, Required } from '@sb/library/base';
import { SnackbarService } from '@sb/library/snackbar';
import { DialogUploadComponent } from '@sb/library/upload';

class ProfilePictureForm extends FormBase {
    UseFaceDetection = Required(ProfileImageCrop);
    ImageToUpload = Optional([File]);
}

@Component({
    selector: 'lib-profile-image-upload-dialog',
    templateUrl: './profile-image-upload-dialog.component.html',
    styleUrls: ['./profile-image-upload-dialog.component.scss']
})
export class ProfileImageUploadDialogComponent extends DialogUploadComponent implements OnInit {
    @Output() upload = new EventEmitter<ProfileImageUploadData>();
    readonly form = ProfilePictureForm.Create(false);
    readonly maxAllowedImageSize: number = FileSize.Maximum.Images.Size25MB;

    constructor(private _SnackBar: SnackbarService) {
        super();
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.form.controls.UseFaceDetection.setValue(ProfileImageCrop.Automatic);
        this.form.patchValue({ImageToUpload: []});
    }

    override EmitFiles(files: File[]): void {
        this._files = files;
    }

    override PrimaryAction(): void {
        this.form.CheckValidity().subscribe(result => {
            if (result) {
                this.upload.emit({Files: this.files, UseFaceDetection: this.form.controls.UseFaceDetection.value === ProfileImageCrop.Automatic});
                super.PrimaryAction();
            }
        });
    }

    override DismissAction(): void {
        super.DismissAction();

        this._SnackBar.DismissSnackbar();
    }

    get ProfileImageCrop(): typeof ProfileImageCrop {
        return ProfileImageCrop;
    }
}
